"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../utils/constants");
var _UpsellAccessoryCard = _interopRequireDefault(require("./UpsellAccessoryCard"));
var _UpsellInsuranceCard = _interopRequireDefault(require("./UpsellInsuranceCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UpsellCardFactory = function UpsellCardFactory(props) {
  switch (props.product.productType) {
    case _constants.PRODUCT_TYPES.ACCESSORY:
      return /*#__PURE__*/_react.default.createElement(_UpsellAccessoryCard.default, props);
    case _constants.PRODUCT_TYPES.INSURANCE:
      return /*#__PURE__*/_react.default.createElement(_UpsellInsuranceCard.default, props);
    default:
      return null;
  }
};
var _default = UpsellCardFactory;
exports.default = _default;